var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React from 'react';
import PropTypes from 'prop-types';
import Popover from '../common/Popover/Popover';
import InstrumentSelectorPopupComponent from './InstrumentSelectorPopupComponent';
import { instrumentPropType } from '../../propTypes/instrumentPropTypes';
import { getBEMClasses } from '../../helpers/cssClassesHelper';
import './InstrumentSelectorComponent.css';
var baseClasses = getBEMClasses('instrument-selector');
var InstrumentSelectorComponent = function (_React$Component) {
  _inherits(InstrumentSelectorComponent, _React$Component);
  function InstrumentSelectorComponent(props) {
    _classCallCheck(this, InstrumentSelectorComponent);
    var _this = _possibleConstructorReturn(this, (InstrumentSelectorComponent.__proto__ || Object.getPrototypeOf(InstrumentSelectorComponent)).call(this, props));
    _this.runLevel1Updates = function () {
      return _this.updateLevel1 = true;
    };
    _this.stopLevel1Updates = function () {
      return _this.updateLevel1 = false;
    };
    _this.onRowClick = function (instrument) {
      _this.popoverRef.toggleShow();
      _this.props.selectInstrument(instrument.InstrumentId);
    };
    _this.popoverRef = null;
    _this.updateLevel1 = true;
    return _this;
  }
  _createClass(InstrumentSelectorComponent, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;
      if (this.props.instruments.length === 0) return;
      var selectedInstrument = this.props.instruments.find(function (instrument) {
        return instrument.InstrumentId === _this2.props.selectedInstrument.InstrumentId;
      });
      if (selectedInstrument) return;
      var instrumentId = this.props.instruments[0].InstrumentId;
      this.props.selectInstrument(instrumentId);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return this.updateLevel1;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;
      var _props = this.props,
        fetching = _props.fetching,
        instruments = _props.instruments,
        selectedInstrument = _props.selectedInstrument,
        selectedRow = _props.selectedRow,
        level1 = _props.level1,
        customClass = _props.customClass,
        showFullNameInstrument = _props.showFullNameInstrument,
        showTriangles = _props.showTriangles;
      var instrumentSymbol = '';
      if (showFullNameInstrument && selectedInstrument.Product1FullName) {
        instrumentSymbol = this.context.t(selectedInstrument.Product1FullName + ' / ' + selectedInstrument.Product2FullName);
      } else {
        instrumentSymbol = selectedInstrument.Symbol;
      }
      return React.createElement(Popover, {
        ref: function ref(_ref) {
          return _this3.popoverRef = _ref;
        },
        trigger: function trigger(props) {
          return React.createElement('button', Object.assign({
            className: baseClasses('trigger')
          }, props, {
            onMouseOver: _this3.stopLevel1Updates,
            onMouseOut: _this3.runLevel1Updates
          }), React.createElement('span', {
            className: baseClasses('symbol')
          }, instrumentSymbol), showTriangles ? React.createElement('div', {
            className: baseClasses('triangles-container')
          }, React.createElement('span', {
            className: 'triangle-up'
          }), React.createElement('span', {
            className: 'triangle-down'
          })) : React.createElement('span', {
            className: baseClasses('triangle')
          }));
        },
        content: React.createElement(InstrumentSelectorPopupComponent, {
          onRowClick: this.onRowClick,
          fetching: fetching,
          instruments: instruments,
          selectedRow: selectedRow,
          level1: level1,
          customClass: customClass,
          showFullNameInstrument: showFullNameInstrument
        }),
        customClass: 'instrument-selector-popover',
        drawArrow: true
      });
    }
  }]);
  return InstrumentSelectorComponent;
}(React.Component);
InstrumentSelectorComponent.contextTypes = {
  t: PropTypes.func.isRequired
};
InstrumentSelectorComponent.propTypes = {
  level1: PropTypes.object.isRequired,
  instruments: PropTypes.array.isRequired,
  fetching: PropTypes.bool.isRequired,
  selectedInstrument: instrumentPropType,
  selectedRow: PropTypes.object.isRequired
};
export default InstrumentSelectorComponent;